var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.632,
    height: 308,
    viewBox: "0 0 257.632 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(149 -6)",
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17210",
    "data-name": "Path 17210",
    d: "M203.829,202.561,72.045,125.554V72.3l131.784,79.966Z",
    transform: "translate(-137.665 -41.289)",
    fill: "#1042f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17211",
    "data-name": "Path 17211",
    d: "M178.93,281.99l42.455-23.426-.375-52.629-43.175,25.554Z",
    transform: "translate(-203.551 -124.518)",
    fill: "#af49ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17212",
    "data-name": "Path 17212",
    d: "M-17.206,519.292-149,442.285l42.283-24.612L25.25,495.856Z",
    transform: "translate(0 -256.387)",
    fill: "#16ebc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17213",
    "data-name": "Path 17213",
    d: "M-31.184,425.335l42.466-23.426V350.141l-42.466,23.437Z",
    transform: "translate(-73.375 -214.329)",
    fill: "#af49ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17214",
    "data-name": "Path 17214",
    d: "M200.4,423.2l42.456-23.426V348.017L200.4,371.443Z",
    transform: "translate(-217.602 -213.006)",
    fill: "#af49ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17215",
    "data-name": "Path 17215",
    d: "M-17.206,334.7l-87.353-51.041v52.062l87.353,51.04v51.757L-149,361.511V309.754h0V205.935l131.794,77.007Z",
    transform: "translate(0 -124.518)",
    fill: "#1042f3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17216",
    "data-name": "Path 17216",
    d: "M17.455,81.417l48.708,29.556,42.466-24.815L-23.338,6-65.621,31.007l45.354,27.52-42.1,24.557L-106.717,56.8-149,81.416l131.794,77.007L25.25,135l-49.165-29.131Z",
    transform: "translate(0 0)",
    fill: "#16ebc3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17217",
    "data-name": "Path 17217",
    d: "M421.422,293.619l42.466-24.946V218.506L421.422,243.28Z",
    transform: "translate(-355.255 -132.347)",
    fill: "#af49ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterbg);
export default __webpack_public_path__ + "static/media/footerbg.b59375a2db40b94713e72ebb22300e56.svg";
export { ForwardRef as ReactComponent };